import { Fragment } from 'react';
import * as PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from 'antd/lib/button';

import { PageWrapper } from 'modules/layout';
import config from 'config/index';

import InfoCategoryList from '../../containers/InfoCategories/InfoCategoryList';

const InfoListPage = ({ history: { push } }) => (
    <PageWrapper
        header={
            <Fragment>
                <FormattedMessage id="info.page.title" />
                <Button
                    type="primary"
                    onClick={() => {
                        push(config.routes.infoCategoriesAdd);
                    }}
                >
                    <FormattedMessage id="info.page.add.infoCategory" />
                </Button>
            </Fragment>
        }
    >
        <InfoCategoryList id="categories" />
    </PageWrapper>
);

InfoListPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
};

export default InfoListPage;
